module.exports = __webpack_public_path__ + "img/затопленны осинник 70х90.6284c26d.jpg";